import React, { memo } from "react";
import { Card, Image } from "react-bootstrap";
import "./PaymentMethods.scss";

const PaymentMethods = ({ selectedBank, setSelectedBank }) => {
  return (
    <Card className="payment-methods-card shadow-sm">
      <Card.Body className="p-4">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div>
            <h5 className="mb-1 fw-bold">Select Payment Gateway</h5>
            <p className="text-muted small mb-0">Choose your preferred payment method</p>
          </div>
          <div className="payment-icon-wrapper">
            <i className="fas fa-credit-card fa-2x text-primary"></i>
          </div>
        </div>

        <div className="payment-options-wrapper">
          <div className="payment-method-item selected">
            <div className="payment-method-content">
              <div className="payment-info">
                <div className="d-flex align-items-center gap-2 mb-1">
                  <Image
                    src="/CreditCard.png"
                    className="payment-logo"
                    alt="Credit Card Payment"
                  />
                  <span className="payment-name">Credit/Debit Card</span>
                </div>
                <p className="payment-description mb-0">
                  Secure payment through our trusted payment gateway
                </p>
              </div>
            </div>
            <div className="selection-indicator">
              <i className="fas fa-check-circle"></i>
            </div>
          </div>
        </div>

        <div className="security-note mt-4 p-3">
          <div className="d-flex align-items-center gap-2">
            <i className="fas fa-shield-alt text-success"></i>
            <div>
              <small className="text-muted d-block">
                <strong>Secure Payment:</strong> You will be redirected to a secure payment page to complete your transaction
              </small>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default memo(PaymentMethods);
